import { render, staticRenderFns } from "./DataCorrectionFormFilesDetails.vue?vue&type=template&id=3f2c341b&scoped=true&"
import script from "./DataCorrectionFormFilesDetails.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionFormFilesDetails.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionFormFilesDetails.vue?vue&type=style&index=0&id=3f2c341b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2c341b",
  null
  
)

export default component.exports